// extracted by mini-css-extract-plugin
export default {"container":"ticketArea__container__NgThK","show":"ticketArea__show__ek1zN","ticket":"ticketArea__ticket__B0Dxq","soldOut":"ticketArea__soldOut__brxoZ"};